module.exports = __webpack_public_path__ + "static/img/sy@2x.0639838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/sy@2x.png
// module id = 1UTQ
// module chunks = 69